import { Pipe, PipeTransform } from '@angular/core';
import { LineSearchStop } from '../../../interfaces/line-search-result';

@Pipe({
  name: 'selectedStopPlaces'
})
export class SelectedTripsPipe implements PipeTransform {
  transform(trips: LineSearchStop[]): LineSearchStop[] {
    return trips?.filter(({ selected }) => selected);
  }
}